const TRACE_LIMIT = 2000;

function safeCopy(value) {
  if (value === undefined) return null;
  try {
    return JSON.parse(JSON.stringify(value));
  } catch (_error) {
    return String(value);
  }
}

export function traceChartNavigation(source, details = {}, { stack = false } = {}) {
  if (typeof window === "undefined") return;
  if (!Array.isArray(window.__ANINA_NAV_TRACE__)) {
    window.__ANINA_NAV_TRACE__ = [];
  }
  if (typeof window.__ANINA_NAV_TRACE_CLEAR__ !== "function") {
    window.__ANINA_NAV_TRACE_CLEAR__ = () => {
      window.__ANINA_NAV_TRACE__.length = 0;
    };
  }

  const entry = {
    sequence: window.__ANINA_NAV_TRACE__.length + 1,
    at: new Date(Date.now()).toISOString(),
    source,
    ...safeCopy(details),
    ...(stack ? { stack: new Error(`ANINA navigation trace: ${source}`).stack } : {}),
  };
  window.__ANINA_NAV_TRACE__.push(entry);
  if (window.__ANINA_NAV_TRACE__.length > TRACE_LIMIT) {
    window.__ANINA_NAV_TRACE__.splice(
      0,
      window.__ANINA_NAV_TRACE__.length - TRACE_LIMIT
    );
  }
}
